import AddUserPage from './AddUser';
import { createAddUserHandle } from './handle';

export default {
  Component: AddUserPage,
  createHandle: createAddUserHandle
};
